import { useQuery } from '@tanstack/react-query';
import { getProducts } from '../services/productService';
import type { ProductDto } from '../types/product';

export function useProducts(categoryId?: number, department?: string) {
  return useQuery<ProductDto[]>({
    queryKey: ['products', categoryId ?? null, department ?? null],
    queryFn: () => getProducts(categoryId, department),
  });
}
